import { Box, Button } from "@mui/material";
import React from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import useUserAccess from "./../../effects/useUserAccess";
import { get } from "lodash";

interface TableActionsProps {
  section: string;
  onView?: (rowData: unknown) => void;
  onEdit?: (rowData: unknown) => void;
  onDelete?: (rowData: unknown) => void;
}

export default function TableActions({
  section,
  onView,
  onEdit,
  onDelete,
}: TableActionsProps) {
  const access = useUserAccess();
  let isUpdateAllowed = get(access, `${section}.Access.U`, false);
  let isDeleteAllowed = get(access, `${section}.Access.D`, false);
  if (typeof section === "string" && section.includes('|')) {
    let listEntity = section.split('|');
    isUpdateAllowed = listEntity.some(key => get(access, `${key}.Access.U`, false));
    isDeleteAllowed = listEntity.some(key => get(access, `${key}.Access.D`, false));
  }
  return (
    <Box display="flex" justifyContent="end" alignItems="center">
      {onView ? (
        <Button
          size="small"
          variant="outlined"
          startIcon={<RemoveRedEyeIcon />}
          style={{ marginRight: 10 }}
          onClick={onView}
        >
          Read
        </Button>
      ) : null}

      {isUpdateAllowed && onEdit ? (
        <Button
          size="small"
          variant="outlined"
          startIcon={<EditIcon />}
          style={{ marginRight: onDelete ? 10 : 0 }}
          onClick={onEdit}
        >
          Edit
        </Button>
      ) : null}

      {isDeleteAllowed && onDelete ? (
        <Button
          size="small"
          variant="outlined"
          color="secondary"
          startIcon={<DeleteForeverIcon />}
          onClick={onDelete}
        >
          Delete
        </Button>
      ) : null}
    </Box>
  );
}
